module.exports = __webpack_public_path__ + "fonts/nunito-sans-v11-latin-700.5cf5f6ff.eot";